<template>
  <div>
    <g-master :name="master.endpoint"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              :modalFieldsSetup="master.modalFieldsSetup"
              @action="masterAction"
              modalWidth="90%"
              :actions="master.actions"
              ref="masterComponent"
    >
    <span slot="estadoRenderer" slot-scope="{text}">
      <a-tag
        :color="text==='ARCHIVADO' ? 'red' : (text === 'CERRADO' ? 'green' : 'blue')">{{text}}</a-tag>
    </span>
    <span slot="etapaRenderer" slot-scope="{text}">
      <a-tag
        color="orange">{{text}}</a-tag>
    </span>
    </g-master>
    <form-proceso-disciplinario @handleOk="loadData" ref="form_proceso"/>
  </div>
</template>

<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    mounted () {
      this.httpClient = new HttpUtil()
    },
    data () {
      return {
        valoresExpandidos: [
          {label: 'Estado', column: 'status_desc'},
          {label: 'Nombre', column: 'full_name'},
          {label: 'Motivo', column: 'h_call_motive'},
          {label: 'Novedad', column: 'h_novelty'},
          {label: 'Observación', column: 'call_obs'},
          {label: 'Creado por', column: 'created_by'},
          {label: 'Otra novedad', column: 'other_novelty'},
          {label: 'Fecha evento', column: 'call_date_desc'},
          {label: 'Creado el', column: 'created_on'},
          {label: 'Modificado por', column: 'modified_by'},
          {label: 'Modificado el', column: 'modified_on'}
        ],
        loadingBtns: {},
        confirmLoading: false,
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 24},
        master: {
          endpoint: 'atention_call',
          tableSetup: {
            tableConfig: {
              rowKey: 'id_atention'
            },
            columns: [
              {title: '#', dataIndex: 'id_atention', sorter: true},
              {title: 'Nombre', dataIndex: 'full_name', sorter: true},
              {title: 'Fecha evento', dataIndex: 'call_date_desc', sorter: true},
              {title: 'Observación', dataIndex: 'call_obs', sorter: true},
              {title: 'Motivo', dataIndex: 'h_call_motive', sorter: true},
              {title: 'Novedad', dataIndex: 'h_novelty', sorter: true},
              {title: 'Otra novedad', dataIndex: 'other_novelty', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'status_desc',
                sorter: true,
                width: 130,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              },
              {
                title: 'Etapa',
                dataIndex: 'etapa_desc',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'etapaRenderer'
                }
              }
            ],
            actions: {
              title: 'Acciones',
              key: 'acciones',
              width: 120,
              fixed: 'right',
              scopedSlots: {customRender: 'hooverableAction'},
              actions: [
                {
                  name: 'detalles',
                  text: 'Detalles',
                  icon: 'search',
                  props: {size: 'small', type: 'link', icon: 'search', style: 'color:green;'}
                },
                {
                  name: 'archivar',
                  text: 'Archivar',
                  icon: 'folder',
                  props: {size: 'small', type: 'link', icon: 'folder-add', style: 'color:blue;'},
                  fnVisible: (record) => {
                    if (!this.$userIsInrol('Query')) {
                      return !['CERRADO', 'ARCHIVADO'].includes(record.status_desc)
                    }
                  },
                  fnLoading: (record) => {
                    return this.loadingBtns[record.id_atention] === record.id_atention
                  }
                },
                {
                  name: 'customEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'},
                  fnVisible: (record) => {
                    if (!this.$userIsInrol('Query')) {
                      return record.status !== '1' && record.step === '0'
                    }
                  }
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link', style: 'color:red;'},
                  fnVisible: (record) => {
                    if (!this.$userIsInrol('Query')) {
                      return record.status !== '1' && record.step === '0'
                    }
                  }
                },
                {
                  name: 'download',
                  text: 'Descargar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'file-pdf', style: 'color: red'},
                  fnVisible: (record) => {
                    return ['CERRADO', 'ARCHIVADO'].includes(record.status_desc)
                  },
                  fnLoading: (record) => {
                    if (!this.$userIsInrol('Query')) {
                      return this.loadingBtns[record.id_atention] === record.id_atention
                    }
                  }
                }
              ]
            },
            customSlots: ['estadoRenderer', 'customAction', 'etapaRenderer']
          },
          actions: [
            {
              name: 'customCreate',
              text: 'Crear',
              permisos: [],
              props: {icon: 'plus', type: 'button'},
              fnVisible: () => !this.$userIsInrol('Query')
            }]
        }
      }
    },
    methods: {
      loadData () {
        this.$refs.masterComponent && this.$refs.masterComponent.$refs.datatable.loadData()
      },
      updateStatus (record, status) {
        this.loadingBtns[record.id_atention] = record.id_atention
        this.loadingBtns = Object.assign({}, this.loadingBtns)
        this.httpClient.getInstance().put('atention_call/' + record.id_atention, {status: status})
          .then(() => {
            Mensajes.success('Correcto', 'Se archivo el proceso disciplinarios correctamente')
            this.$refs.masterComponent.$refs.datatable.loadData()
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible guardar la información, contacte al administrador.')
          }).then(() => {
          delete this.loadingBtns[record.id_atention]
          this.loadingBtns = Object.assign({}, this.loadingBtns)
        })
      },
      masterAction (action) {
        switch (action.action) {
          case 'customCreate':
            this.$refs.form_proceso.showModal()
            break
          case 'customEdit':
            this.$refs.form_proceso.showModal(action.record)
            break
          case 'archivar':
            this.updateStatus(action.record, true)
            this.$emit('archivado')
            break
          case 'detalles':
            this.$emit('detalle', {detalle: action.record, valoresExpandidos: this.valoresExpandidos})
            break
          case 'download':
            this.downloadFile(action.record)
            break
        }
      },
      downloadFile (record) {
        this.loadingBtns[record.id_atention] = record.id_atention
        this.loadingBtns = Object.assign({}, this.loadingBtns)

        this.httpClient.getInstance().post('atention_call/download', {
          params: {
            id_atention: record.id_atention
          }
        }, {responseType: 'arraybuffer'}).then((response) => {
          let fileURL = new Blob([response.data], {type: 'application/octet-stream'})
          fileURL = window.URL.createObjectURL(fileURL)
          let fileLink = document.getElementById('file_link_elm')
          if (fileLink === null) {
            fileLink = document.createElement('a')
            fileLink.setAttribute('id_atention', 'file_link_elm')
            document.body.appendChild(fileLink)
          }
          fileLink.setAttribute('href', fileURL)
          fileLink.setAttribute('download', response.headers['x-nombre-archivo'])
          fileLink.click()
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible descargar el archivo.')
        }).then(() => {
          delete this.loadingBtns[record.id_atention]
          this.loadingBtns = Object.assign({}, this.loadingBtns)
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/ReporteNovedad/ProcesosDisciplinarios.vue